export enum Visibility {
    All = "All",
    Sender = "Sender"
}
